<template>
    <modal id="job_position-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('job_position')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.JOBPOSITION'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('title')"
                        type="text"
                        v-model="formData.title"
                        :placeholder="$placeholder('title')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'title')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('department')"
                        list-value-field="name"
                        v-model="formData.department_id"
                        :chooseLabel="$t('department')"
                        :error-message="$errorMessage(errors, 'department_id')"
                        :fetch-url="SELECTABLE_DEPARTMENT"
                    />
                </div>
            </div>

        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {SELECTABLE_DEPARTMENT} from "../../../../Config/ApiUrl";

import {
    addChooseInSelectArray,
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import countries from "../../../../Components/View/Employee/Helper/countries";
import { axiosPost} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "JobPositionCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {
                title: '',
                department_id: null
            },
            SELECTABLE_DEPARTMENT,
        }
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData = formDataAssigner(new FormData, formData);

            let url = this.apiUrl.JOBPOSITION;
            if(this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#job-position-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'job-position-table');
                window.location.reload();
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status != 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {

            this.formData = {};
            $('#job-position-modal').modal('hide');
            this.toastAndReload(data.message, 'job-position-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
